export enum AXIOS_METHODS {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum HEALTH_CHECK {
  YES = 'YES',
  NO = 'NO',
  NULL = 'NULL',
}

export enum ENV {
  DEV = 'development',
  STAG = 'staging',
  PROD = 'production',
}

export enum DISCOUNT {
  THIRTY = 30,
  FIFTY = 50,
}

export enum FACIALS {
  INFLUENCER = 'Influencer Facial',
  LASER = 'Laser Facial',
}

export enum CONFIRMATION_GA4_EVENTS {
  SHARED_APPOINTMENT_GA4 = 'shared_appointment_ga4',
  CLICK_ADD_TO_CALENDAR = 'click_add_to_calendar',
  CLICK_MANAGE_APPOINTMENTS = 'click_manage_appointments',
  MEMBERSHIP_PURCHASE_GA4 = 'membership_purchase_ga4',
}

export enum GA4_EVENTS {
  CONTINUE_ENHANCEMENT_SELECTED = 'continue_enhancement_selected_ga4',
  SKIP_ENHANCEMENT_BUTTON = 'enhancement_skipped_ga4',
  APPOINTMENT_DATE_TIME_SELECTED = 'appointment_selected_ga4',
  HEALTH_CHECK_NO_GA4 = 'health_check_no_ga4',
  HEALTH_CHECK_YES_GA4 = 'health_check_yes_ga4',
  VIEW_CART_GA4 = 'view_cart',
  REMOVE_FROM_CART_GA4 = 'remove_from_cart',
  MEMBERSHIP_FLOW_STARTED_GA4 = 'membership_flow_started_ga4',
  MEMBERSHIP_LOCATION_SELECTED_GA4 = 'membership_location_selected_ga4',
  LOCATION_SELECTED_GA4 = 'location_selected_ga4',
  MEMBERSHIP_VIEW_CART_GA4 = 'membership_view_cart_ga4',
  PURCHASE_GA4 = 'purchase',
}

export enum KLAVIYO_EVENTS {
  LOCATION_SELECTED = 'Location Selected',
  BASE_SERVICE_SELECTED = 'Base Service Selected',
  ENHANCEMENT_SELECTED = 'Enhancement Selected',
  DATETIME_ST_SELECTED = 'Date/time ST Selected',
  CONTRAINDICATIONS_SCREEN_SELECTED = 'Contraindications Screen Selected',
}

const isProduction = process.env.REACT_APP_ENV === 'production'

export const MALIBLE_PAGE = {
  LOCATIONS: isProduction
    ? '69986ba1992e8e764e36a9cb'
    : '6a200a3bf54b93799f45ab32',
  MEMBERSHIP_LOCATIONS: isProduction
    ? '69df8522e372230dc9061371'
    : '6a200a71f54b93799f45aba8',
  SERVICE: isProduction
    ? '69986da6992e8e764e36aa31'
    : '6a1ff306710d91df07236733',
  ENHANCEMENTS: isProduction
    ? '699870da6c521e15318f31d7'
    : '6a1fedf7f54b93799f45a219',
  HEALTH_CHECK: isProduction
    ? '69a5432faa070f085825760a'
    : '6a200a8f710d91df07236c7f',
  CONFIRMATION: isProduction
    ? '69a5560daa070f08582577b8'
    : '6a200aab66a5c5560afcd787',
} as const
